import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { MetricsBar } from '../components/MetricsBar';
import { TrustStrip } from '../components/TrustStrip';
import { AboutNarrative } from '../components/AboutNarrative';
import { ApproachSteps } from '../components/ApproachSteps';
import { Recognition } from '../components/Recognition';
import { Credentials } from '../components/Credentials';
import { SkillsCloud } from '../components/SkillsCloud';
export function AboutPage() {
  return <>
      <PageHeader label="Executive Biography" title="A global executive and strategic advisor, 39 years in" description="Enterprise procurement, corporate real estate, workplace strategy, and corporate services led across Parexel, Syneos Health, MetLife, and Kendle International." data-id="element-438" data-mp="3mdnthlmpades" />
      <MetricsBar data-id="element-439" data-mp="1gjxj899we9mh" />
      <TrustStrip data-id="element-440" data-mp="1gkgvpags45t4" />
      <AboutNarrative showLabel={false} data-id="element-441" data-mp="1gimiyjfnvk04" />
      <ApproachSteps data-id="element-442" data-mp="1blmbc435y96w" />
      <Recognition data-id="element-443" data-mp="1bn769ute3u5a" />
      <Credentials data-id="element-444" data-mp="1bmnr2lv4jjuy" />
      <SkillsCloud data-id="element-445" data-mp="2ew7h1mevxb4p" />
    </>;
}